<template>
  <span>
    <span v-for="(type, index) in education" :key="`type-${index}`">
      {{ type.label }}
      <span v-if="index !== education.length - 1"> &middot; </span>
    </span>
  </span>
</template>

<script setup>
defineProps({
  education: {
    type: Array,
    default: () => [],
  },
})
</script>
